<div class="stats-cotainer">
    <div class="navbar">
        <app-home-nav></app-home-nav>
    </div>
    <div appLangType class="content-info">
        <router-outlet></router-outlet>
    </div>
</div>
